import Button from '../../../../core/components/Button.tsx';
import * as React from 'react';
import { usePushNotifications } from '../../../../core/utils/usePushNotifications.ts';
import { useTranslation } from 'react-i18next';
import classnames from '../../../../core/utils/classnames.tsx';
import { withIcon } from '../../../../core/components/Icon.tsx';
import { faBell, faBellSlash } from '@fortawesome/pro-regular-svg-icons';

const NotificationsIcon = withIcon(faBell);
const NotificationsOffIcon = withIcon(faBellSlash);

const AssistanceNotificationsCard = ({
    className,
    record,
    documentType,
    ...props
}: {
    className?: string;
    record: any;
    documentType: string;
}) => {
    const { t } = useTranslation('assistance');

    const { isSupported, isSubscribed, subscribe, unsubscribe } = usePushNotifications({
        recordId: record?.id,
        documentType: documentType,
    });

    if (!isSupported) {
        return null;
    }

    if (isSubscribed) {
        return (
            <div
                className={classnames(
                    'flex flex-col items-center gap-4  border border-line-strong rounded-md p-5 bg-surface-strong mt-6',
                    className
                )}
                {...props}
            >
                <p className="flex items-center gap-2 text-sm text-content-strong text-center font-medium">
                    <span>{t('notifications.subscribedProcessingTitle')}</span>
                </p>
                <p className="text-sm text-content-strong max-w-80 w-full text-center">
                    {t('notifications.subscribedProcessingMessage')}
                </p>
                <Button onClick={() => unsubscribe()} className="mt-1 flex items-center gap-1">
                    <NotificationsOffIcon />
                    {t('notifications.unsubscribeLink')}
                </Button>
            </div>
        );
    } else {
        return (
            <div
                className={classnames(
                    'flex flex-col items-center gap-4  border border-line-strong rounded-md p-5 bg-surface-strong mt-6',
                    className
                )}
                {...props}
            >
                <p className="flex items-center gap-2 text-sm text-content-strong text-center font-medium">
                    <span>{t('notifications.notSubscribedProcessingTitle')}</span>
                </p>
                <p className="text-sm text-content-strong max-w-80 w-full text-center">
                    {t('notifications.notSubscribedProcessingMessage')}
                </p>
                <Button onClick={() => subscribe()} className="mt-1 flex items-center gap-1">
                    <NotificationsIcon />
                    {t('notifications.subscribeLink')}
                </Button>
            </div>
        );
    }
};

export default AssistanceNotificationsCard;
